import { KeepAlive } from 'vue'

const routes = [
  {
    path: '/spfc',
    redirect: { name: 'SpfcDetail' },
    meta: { layout: 'default' },
    children: [
      // 체육시설 상세
      {
        path: 'detail/:instId',
        name: 'SpfcDetail',
        meta: { layout: 'default', menu: 'spfc'},
        component: () => import('@/pages/spfc/SpfcDetailView.vue'),
        props: true
      },
      {
        path: 'rsvt/:instId/:ptFcltClsfId',
        name: 'SpfcRsvt',
        meta: { layout: 'default', menu: 'spfc' },
        component: () => import('@/pages/spfc/SpfcRsvtView.vue'),
        props: (route) => ({
          ptFcltId: route.query.ptFcltId,
          rsvtYmd: route.query.rsvtYmd,
          pouDcd: route.query.pouDcd,
          useHr: route.query.useHr,
          rsvtBgngHm: route.query.rsvtBgngHm,
          rsvtEndHm: route.query.rsvtEndHm
        })
      },
      {
        path: 'done',
        name: 'SpfcDone',
        meta: { layout: 'default', menu: 'spfc' },
        component: () => import('@/pages/spfc/SpfcDoneView.vue')
      }
    ]
  }
]

export default routes


